import { Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell";
import { Home } from "./pages/Home";
import { Feed } from "./pages/Feed";
import { Chat } from "./pages/Chat";
import { Store } from "./pages/Store";
import { AdminDashboard } from "./pages/AdminDashboard";
import { AuthPage } from "./pages/AuthPage";
import { SectionPage } from "./pages/SectionPage";
import { PostDetail } from "./pages/PostDetail";
import {
  BookmarksPage,
  DirectMessagePage,
  FollowListPage,
  InboxPage,
  PrivacyPolicyPage,
  ProfilePage,
  SearchPage,
  SettingsPage
} from "./pages/SimplePages";

export function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/chat/:roomId" element={<Chat />} />
        <Route path="/store" element={<Store />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/users/:userId" element={<ProfilePage />} />
        <Route path="/users/:userId/followers" element={<FollowListPage listType="followers" />} />
        <Route path="/users/:userId/following" element={<FollowListPage listType="following" />} />
        <Route path="/bookmarks" element={<BookmarksPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/inbox/:conversationId" element={<DirectMessagePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/sections/:sectionId" element={<SectionPage />} />
        <Route path="/posts/:collectionName/:postId" element={<PostDetail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
